<div class="role-chips">
  <div class="role-chips__list" role="group" aria-label="Filtrar por tipo de usuário">
    @for (chip of chips(); track chip.roleId) {
      <button
        type="button"
        class="role-chips__chip"
        [class.is-on]="chip.roleId === selected()"
        [attr.aria-pressed]="chip.roleId === selected()"
        (click)="selectedChange.emit(chip.roleId)">
        {{ chip.label }} <b>{{ chip.count }}</b>
      </button>
    }
  </div>
  <div class="role-chips__legend" aria-hidden="true">
    <span><i class="role-chips__dot role-chips__dot--read"></i>Leitura</span>
    <span><i class="role-chips__dot role-chips__dot--write"></i>Gravação</span>
  </div>
</div>
